<template>
  <div>
    <div @click="visible = true">
      <slot />
    </div>

    <a-modal
      title="选择项目投标申请"
      :visible="visible"
      @cancel="cancel"
      :footer="null"
      width="900px"
    >
      <a-input-search
        placeholder="请输入项目名称搜索"
        enter-button
        @search="onSearch"
      ></a-input-search>

      <Padding />

      <a-table
        bordered
        :data-source="list"
        :loading="loading"
        @change="onChange"
        :pagination="{
          total,
          current,
          pageSize,
          showTotal: (total) => `共 ${total} 条记录`,
        }"
        :rowClassName="() => 'clickable'"
        :customRow="
          (record) => {
            return {
              on: {
                click: () => {
                  onTableRowClick(record);
                },
              },
            };
          }
        "
        :scroll="{ x: 500 }"
        style="table-layout: fixed"
      >
        <a-table-column title="序号" :width="60" align="center">
          <template slot-scope="text, record, index">
            {{ (current - 1) * pageSize + index + 1 }}
          </template>
        </a-table-column>
        <a-table-column title="项目编号" data-index="projectNum" :width="160" />
        <a-table-column title="项目名称" data-index="projectName" minWidth="340" />
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import { getProjectOptions } from "@/api/market/project";
export default {
  data() {
    return {
      visible: false,

      searchValue: "",

      loading: false,
      current: 1,
      pageSize: 10,
      list: [],
      total: 0,
    };
  },

  watch: {
    visible(newValue) {
      if (newValue) {
        if (this.list.length === 0) {
          this.getList();
        }
      }
    },
  },

  methods: {
    getList() {
      this.loading = true;
      getProjectOptions({
        pageNum: this.current,
        pageSize: this.pageSize,
        projectName: this.searchValue,
        status: "End"
      })
        .then((res) => {
          if (res && Array.isArray(res.list)) {
            this.list = Object.freeze(res.list);
            this.total = res.totalSize;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onChange(pagination) {
      this.current = pagination.current;
      this.getList();
    },

    onSearch(value) {
      this.searchValue = value;
      this.current = 1;
      this.getList();
    },

    onTableRowClick(record) {
      this.$emit("change", record);
      this.visible = false;
    },

    cancel() {
      this.visible = false;
    },
  },
};
</script>
